import { ICON_DEFAULT_FOREGROUND_COLOR } from '../../../graphConstants';
import { makeTag } from '../../../svg/utils';
import { range } from '../../../utils/numbers';
import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import {
  createSquareNodeTypeIcon,
  getRoundedRectanglePath,
  wrapNodeIconInSvgTag,
} from '../common';
import { drawSquareBackground } from '../drawIconBackground';

const ICON_SIZE = 40;

// "PHONE" text generated with text-to-svg and Century Gothic normal
// see https://ipfabric.atlassian.net/wiki/spaces/devOps/pages/1623457793/Snippets#Generate-svg-path-from-text%2Ffont

const PHONE_TEXT_PATH =
  'M.0869 1.0059L.0869 .2876L.23 .2876Q.353 .2876 .396 .2983L.396 .2983Q.4575 .3135 .4966 .3606Q.5356 .4077 .5356 .479L.5356 .479Q.5356 .5508 .4976 .5974Q.4595 .644 .3926 .6602L.3926 .6602Q.3438 .6719 .21 .6719L.21 .6719L.1587 .6719L.1587 1.0059L.0869 1.0059ZM.2856 .3574L.1587 .3574L.1587 .6016L.2803 .603Q.354 .603 .3882 .5896Q.4224 .5762 .4419 .5461Q.4614 .5161 .4614 .479L.4614 .479Q.4614 .4429 .4419 .4128Q.4224 .3828 .3904 .3701Q.3584 .3574 .2856 .3574L.2856 .3574ZM.6782 1.0059L.6782 .2876L.7505 .2876L.7505 .5889L1.1157 .5889L1.1157 .2876L1.188 .2876L1.188 1.0059L1.1157 1.0059L1.1157 .6592L.7505 .6592L.7505 1.0059L.6782 1.0059ZM1.7046 .2695L1.7046 .2695Q1.8677 .2695 1.9775 .3784Q2.0874 .4873 2.0874 .6465L2.0874 .6465Q2.0874 .8042 1.9778 .9141Q1.8682 1.0239 1.7104 1.0239L1.7104 1.0239Q1.5508 1.0239 1.4409 .9146Q1.3311 .8052 1.3311 .6499L1.3311 .6499Q1.3311 .5464 1.3811 .458Q1.4312 .3696 1.5176 .3196Q1.604 .2695 1.7046 .2695ZM1.708 .3398L1.708 .3398Q1.6284 .3398 1.5571 .3813Q1.4858 .4229 1.4458 .4932Q1.4058 .5635 1.4058 .6499L1.4058 .6499Q1.4058 .7778 1.4944 .866Q1.583 .9541 1.708 .9541L1.708 .9541Q1.7915 .9541 1.8625 .9136Q1.9336 .873 1.9734 .8027Q2.0132 .7324 2.0132 .6465L2.0132 .6465Q2.0132 .561 1.9734 .4919Q1.9336 .4229 1.8613 .3813Q1.7891 .3398 1.708 .3398ZM2.3062 1.0059L2.2319 1.0059L2.2319 .2876L2.2476 .2876L2.7251 .8374L2.7251 .2876L2.7959 .2876L2.7959 1.0059L2.7798 1.0059L2.3062 .4629L2.3062 1.0059ZM2.9717 1.0059L2.9717 .2876L3.3833 .2876L3.3833 .3584L3.0435 .3584L3.0435 .583L3.3804 .583L3.3804 .6533L3.0435 .6533L3.0435 .9351L3.3804 .9351L3.3804 1.0059L2.9717 1.0059Z';
const FONT_SIZE = 6.4;
const KEYPAD_STEP = 4.8;

function createPhoneIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const drawKeypadKey = (x: number, y: number) =>
    makeTag('rect', {
      x,
      y,
      width: 4,
      height: 4,
      fill: ICON_DEFAULT_FOREGROUND_COLOR,
    });

  const icon = `
    ${drawSquareBackground(ICON_SIZE, opts.style)}
    ${makeTag('path', {
      d: getRoundedRectanglePath(3.2, 2.8, 10.4, 34.8, 2),
      fill: ICON_DEFAULT_FOREGROUND_COLOR,
    })}
    ${makeTag('path', {
      d: PHONE_TEXT_PATH,
      transform: `translate(4.4 31.2) rotate(270) scale(${FONT_SIZE})`,
      fill: '#000',
    })}
    ${makeTag('rect', {
      x: 19.2,
      y: 4.8,
      width: 17.6,
      height: 12,
      fill: ICON_DEFAULT_FOREGROUND_COLOR,
    })}
    ${range(0, 3)
      .map((x) =>
        range(0, 4)
          .map((y) =>
            drawKeypadKey(21.2 + x * KEYPAD_STEP, 18.8 + y * KEYPAD_STEP),
          )
          .join(''),
      )
      .join('')}
  `;

  return wrapNodeIconInSvgTag(icon, ICON_SIZE, ICON_SIZE, 'topLeft', opts);
}

export const phoneIcon: NodeTypeIcon = createSquareNodeTypeIcon(
  ICON_SIZE,
  createPhoneIcon,
);
